import { Locale } from '@instructure/ui-i18n';
export function getLocale() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props.locale || context.locale || Locale.browserLocale();
}
export default getLocale;